import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as MirrorHorizontalIcon } from 'assets/icons/mirror_horizontal.svg';
import { ReactComponent as MirrorVerticalIcon } from 'assets/icons/mirror_vertical.svg';
import { useTranslation } from 'react-i18next';
import { useWidget } from 'widgets/sdk';

import { ImageWidgetData } from '../ImageWidget.types';

export const MirrorImage = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'imageToolbar.toolbar' });
  const { updateWidget, mirror = {} } = useWidget<ImageWidgetData>();

  const flipVerticalLabel = t('flipVertical');
  const flipHorizontalLabel = t('flipHorizontal');

  const onUpdateMirrorVertical = (): void => updateWidget({ mirror: { isVertical: !mirror.isVertical } });
  const onUpdateMirrorHorizontal = (): void => updateWidget({ mirror: { isHorizontal: !mirror.isHorizontal } });

  return (
    <>
      <Tooltip hasArrow placement='bottom' label={flipVerticalLabel} bg='black'>
        <IconButton
          onClick={onUpdateMirrorVertical}
          size='sm'
          variant={'icon-btn-toolbar-option'}
          aria-label={flipVerticalLabel}
          icon={<MirrorVerticalIcon />}
        />
      </Tooltip>
      <Tooltip hasArrow placement='bottom' label={flipHorizontalLabel} bg='black'>
        <IconButton
          onClick={onUpdateMirrorHorizontal}
          size='sm'
          variant={'icon-btn-toolbar-option'}
          aria-label={flipHorizontalLabel}
          icon={<MirrorHorizontalIcon />}
        />
      </Tooltip>
    </>
  );
};
